<form [formGroup]="addressForm" (ngSubmit)="saveAddress()">
  <div class="bg-white p-[15px]">
    <div
      class="grid md:grid-cols-2 grid-cols-1 gap-[10px] mb-[10px] text-left rounded-[5px]"
    >
      @if (slot?.widget?.data?.value?.backButton?.value?.status) {
        <span> <!-- for spacing --></span>
        <span
          class="flex items-center gap-[4px] bg-[#ffffff] md:text-[14px] text-[12px] text-center max-w-[240px] md:ml-auto font-medium md:pl-[13px] md:pr-[13px] cursor-pointer md:pt-[13px] md:pb-[13px] text-[#5b5b5b]"
          (click)="performAction(slot.widget.data.value.backButton?.action)"
        >
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1.5em"
              height="1.5em"
              viewBox="0 0 512 512"
            >
              <path
                fill="none"
                stroke="black"
                stroke-miterlimit="10"
                stroke-width="32"
                d="M256 64C150 64 64 150 64 256s86 192 192 192s192-86 192-192S362 64 256 64Z"
              />
              <path
                fill="none"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                d="m296 352l-96-96l96-96"
              />
            </svg>
          </span>
          {{ slot.widget.data.value.backButton?.value?.text }}
        </span>
      }

      <div>
        @if (addressForm.get('businessVerificationOption').value === 'GST') {
          <div>
            <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
              @if (isSignUp()) {
                GST Number
              } @else {
                Add GSTIN and click verify to claim input tax credit on this
                purchase.
              }
            </div>
            <div class="relative">
              <input
                formControlName="gstin"
                maxlength="15"
                oninput="this.value = this.value.toUpperCase()"
                [disabled]="readOnly().gstin"
                [readonly]="readOnly().gstin"
                type="text"
                class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px] mb-[10px]"
                style="border-color: #dfdfdf !important"
                (keyup)="verifiedGstinNumber()"
              />
              @if (!gstinVerified()) {
                <button
                  (click)="verifyGST()"
                  type="button"
                  class="h-[40px] absolute inset-y-0 right-0 bg-[#D0F0C0] hover:bg-[#3BB000] text-[#000000] hover:text-[#FFFFFF] px-[10px] md:text-[14px] text-[13px]"
                >
                  Verify
                </button>
              }
              @if (addressForm.get('gstin').value && gstinVerified()) {
                <img
                  title="gst verified"
                  class="absolute top-[10px] right-[5px]"
                  alt="green check"
                  [ngSrc]="data?.verifiedGstinImg"
                  [height]="20"
                  [width]="20"
                />
              }
            </div>
            @if (shouldShowGstinError()) {
              <div class="text-[12px] text-[#FF0000] my-[2px]">
                {{
                  addressForm.get('gstin')?.errors?.invalidGstinError ||
                    'Enter a valid GSTIN number.'
                }}
              </div>
            }
          </div>
        }
      </div>

      @if (showGSTOptions()) {
        <div
          class="absolute bg-white border border-gray-300 p-4 z-50 shadow-2xl"
        >
          <div class="mb-2">
            <h2>
              Found {{ gstOptions.length }} gstin for PAN:
              {{ addressForm.value.pan }}
            </h2>
            <span> Select one gst to continue </span>
          </div>
          <ul class="mt-3 list-none h-80 overflow-scroll shadow-inner">
            @for (gstOption of gstOptions; track gstOption) {
              <li
                (click)="selectOption(gstOption)"
                class="cursor-pointer p-4 border-solid border-white border-2 hover:border-black"
              >
                {{ gstOption.state }} - {{ gstOption.gstin }}
              </li>
            } @empty {
              No GSTIN Registered for this pan: {{ addressForm.value.pan }}
            }
          </ul>
          <button
            type="button"
            class="p-3 m-2 cursor-pointer bg-orange-300"
            (click)="closeGSTOptions()"
          >
            Close
          </button>
        </div>
      }

      @if (verifiedGstin() && addressForm.get('gstin').value) {
        @if (addressForm.get('businessVerificationOption').value != 'GST') {
          <div>
            <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
              GST Number
            </div>
            <div class="relative">
              <input
                formControlName="gstin"
                type="text"
                oninput="this.value = this.value?.toUpperCase()"
                class="px-[10px] rounded-sm border border-solid bg-transparent w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px]"
                style="border-color: #dfdfdf !important"
              />
            </div>
          </div>
        }

        <div class="">
          <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
            Business Name<span class="md:text-[14px] text-[#eb3406] text-[12px]"
              >*</span
            >
          </div>
          <div class="relative">
            <input
              formControlName="businessName"
              type="text"
              class="px-[10px] rounded-sm border border-solid bg-transparent w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px]"
              style="border-color: #dfdfdf !important"
            />
          </div>
        </div>
      }

      <div class="">
        <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
          Name<span class="md:text-[14px] text-[#eb3406] text-[12px]">*</span>
        </div>

        <div class="relative">
          <input
            formControlName="name"
            required
            type="text"
            class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px] mb-[10px]"
            style="border-color: #dfdfdf !important"
            maxlength="40"
            minlength="3"
          />
        </div>
        @if (addressForm.get('name').value && addressForm.get('name').errors?.['minlength']) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            Please enter a name with at least 3 characters.
          </div>
        }
        @if (addressForm.get('name').value && addressForm.get('name').errors?.['pattern']) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            Name contains only letters, spaces, and hyphens. Special characters
            are not allowed.
          </div>
        }
        @if (
          addressForm.get('name').touched &&
          !addressForm.get('name').value &&
          addressForm.get('name').errors
        ) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            Please enter a valid name
          </div>
        }
      </div>
      <div class="">
        <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
          Email<span class="md:text-[14px] text-[#eb3406] text-[12px]">*</span>
        </div>
        <div class="relative">
          <input
            formControlName="email"
            required
            type="text"
            [disabled]="readOnly().email"
            [readonly]="readOnly().email"
            class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px]"
            style="border-color: #dfdfdf !important"
            maxlength="40"
            [value]="
              StringUtils.isValidEmail(data?.profileEmail)
                ? data?.profileEmail
                : ''
            "
          />
        </div>
        @if (
          addressForm.get('email').touched && addressForm.get('email').errors
        ) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            Enter a valid email.
          </div>
        }
      </div>
      <div class="">
        <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
          Mobile<span class="md:text-[14px] text-[#eb3406] text-[12px]">*</span>
        </div>
        <div class="relative">
          <input
            formControlName="phone"
            type="text"
            maxlength="10"
            [disabled]="readOnly().phone"
            [readonly]="readOnly().phone"
            class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px]"
            style="border-color: #dfdfdf !important"
            (input)="onPhoneInputChange($event)"
            #phone
          />
          @if (!isSignUp() && showSendOTPButton()) {
            <button
              (click)="sendOTP()"
              type="button"
              class="h-[40px] absolute inset-y-0 right-0 bg-[#D0F0C0] hover:bg-[#3BB000] text-[#000000] hover:text-[#FFFFFF] px-[10px] text-[13px] disabled:bg-[#DFDFDF] disabled:text-[#5B5B5B] disabled:cursor-auto"
              [disabled]="!isPhoneNumberValid()"
            >
              Send OTP
            </button>
          }
        </div>

        @if (
          addressForm.get('phone').touched && addressForm.get('phone').errors
        ) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            Enter a valid 10 digit phone number.
          </div>
        }
      </div>

      @if (showOTPVerification()) {
        <div class=""></div>

        <div class="">
          <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
            Otp<span class="md:text-[14px] text-[#eb3406] text-[12px]">*</span>
          </div>
          <div class="relative">
            <input
              formControlName="otp"
              onkeypress="
                return (
                  (event.charCode != 8 && event.charCode == 0) ||
                  (event.charCode >= 48 && event.charCode <= 57)
                );
              "
              type="text"
              maxlength="6"
              class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px]"
              style="border-color: #dfdfdf !important"
            />
            @if (addressForm.get('otp').value) {
              <button
                (click)="verifyOTP()"
                type="button"
                class="h-[40px] absolute inset-y-0 right-0 bg-[#D0F0C0] hover:bg-[#3BB000] text-[#000000] hover:text-[#FFFFFF] px-[10px] text-[13px]"
              >
                Verify
              </button>
              @if (addressForm.get('otp').errors?.error) {
                <div class="text-[12px] text-[#FF0000] my-[2px]">
                  {{ addressForm.get('otp').errors.error }}
                </div>
              }
            }
          </div>
        </div>
      }

      <div class="">
        <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
          Alternate Mobile
        </div>
        <div class="relative">
          <input
            formControlName="alternatePhone"
            (input)="onInputChange($event)"
            type="text"
            maxlength="10"
            class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px] mb-[10px]"
            style="border-color: #dfdfdf !important"
          />
        </div>
        @if (
          addressForm.get('alternatePhone').touched &&
          addressForm.get('alternatePhone').errors
        ) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            Enter a valid 10 digit phone number.
          </div>
        }
      </div>

      <div class="">
        <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
          Flat, House no., Building, Company, Apartment<span
            class="md:text-[14px] text-[#eb3406] text-[12px]"
            >*</span
          >
        </div>
        <div class="relative">
          <input
            formControlName="address"
            required
            type="text"
            class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px] mb-[10px]"
            style="border-color: #dfdfdf !important"
            maxlength="100"
          />
        </div>
        @if (
          addressForm.get('address').touched &&
          addressForm.get('address').errors
        ) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            @if (addressForm.get('address').errors?.maxlength) {
              Address field cannot exceed 100 characters.
            } @else {
              Address is required and cannot contain only spaces.
            }
          </div>
        }
      </div>

      <div class="">
        <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
          Area, Street, Sector, Village
        </div>
        <div class="relative">
          <input
            formControlName="address2"
            type="text"
            class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px] mb-[10px]"
            style="border-color: #dfdfdf !important"
            maxlength="100"
          />
        </div>
        @if (addressForm.get('address2').touched && addressForm.get('address2').errors) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            @if (addressForm.get('address2').errors?.maxlength) {
              Address field cannot exceed 100 characters.
            } @else {
              Please enter a valid address detail.
            }
          </div>
        }
      </div>

      <div class="">
        <label
          class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]"
          for="pincode"
          >Pincode<span class="md:text-[14px] text-[#eb3406] text-[12px]"
            >*</span
          ></label
        >
        <div class="relative">
          <input
            required
            type="text"
            id="pincode"
            maxlength="6"
            formControlName="pincode"
            (input)="onPincodeChange()"
            style="border-color: #dfdfdf !important"
            [disabled]="readOnly().pincode"
            [readonly]="readOnly().pincode"
            onkeypress="
              return (
                (event.charCode != 8 && event.charCode == 0) ||
                (event.charCode >= 48 && event.charCode <= 57)
              );
            "
            class="px-[10px] rounded-none border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px]"
          />
        </div>

        @if (shouldShowPincodeError()) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            {{
              addressForm.get('pincode').errors?.invalidPincodeError ||
                'Enter a valid 6 digit pincode.'
            }}
          </div>
        }

        @if (data?.isPincodeValid && !hideError()) {
          <div class="text-[12px] text-[#FF0000] my-[2px]">
            {{ data?.isPincodeValid }}
          </div>
        }
      </div>

      <div class="">
        <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
          Landmark
        </div>
        <div class="relative">
          <input
            formControlName="landmark"
            type="text"
            class="px-[10px] rounded-none border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px]"
            style="border-color: #dfdfdf !important"
            maxlength="60"
          />
        </div>
        <div class="mt-[2px] text-[12px] text-[#BCBCBC]">
          Landmark will ensure faster delivery
        </div>
      </div>

      <div class="grid grid-cols-2 gap-[10px]">
        <div class="">
          <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
            City<span class="md:text-[14px] text-[#eb3406] text-[12px]">*</span>
          </div>
          <div class="relative">
            <input
              formControlName="city"
              type="text"
              class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px] mb-[10px]"
              style="border-color: #dfdfdf !important"
            />
          </div>
        </div>

        <div class="">
          <div class="md:text-[14px] text-[13px] text-[#5B5B5B] mb-[5px]">
            State<span class="md:text-[14px] text-[#eb3406] text-[12px]"
              >*</span
            >
          </div>
          <div class="relative">
            <input
              formControlName="state"
              type="text"
              class="px-[10px] rounded-sm border border-solid bg-white w-full focus:ring-0 focus:outline-none focus:shadow-outline h-[40px] mb-[10px]"
              style="border-color: #dfdfdf !important"
            />
          </div>
        </div>
      </div>

      <!-- <div> -->
      <!-- do not remove -->
      <!-- to create separation from address info and business info -->
      <!-- </div> -->

      @if (data?.showMakeAddressBox) {
        <div class="flex items-center flex-wrap gap-[10px]">
          <div class="flex items-center gap-[10px]">
            <input
              type="checkbox"
              formControlName="default"
              id="default-checkbox-1"
              value=""
              class="w-[15px] h-[15px] bg-transparent border border-solid rounded accent-[#F94D00]"
              style="border-color: #5b5b5b !important"
            />
            <label
              for="default-checkbox-1"
              class="md:text-[14px] text-[13px] font-semibold text-[#000000]"
            >
              Make as Primary Address
            </label>
          </div>
          @if (addressType === 'billing' && !addressId) {
            <div class="flex items-center gap-[10px]">
              <input
                type="checkbox"
                formControlName="sameShippingAddress"
                id="default-checkbox-2"
                style="border-color: #5b5b5b !important"
                class="w-[15px] h-[15px] bg-transparent border border-solid rounded accent-[#F94D00]"
              />
              <label
                for="default-checkbox-2"
                class="md:text-[14px] text-[13px] font-semibold text-[#000000]"
              >
                Make this Shipping address
              </label>
            </div>
          }
          @if (addressType === 'shipping' && !addressId) {
            <div class="flex items-center gap-[10px]">
              <input
                type="checkbox"
                formControlName="sameBillingAddress"
                id="default-checkbox-3"
                style="border-color: #5b5b5b !important"
                class="w-[15px] h-[15px] bg-transparent border border-solid rounded accent-[#F94D00]"
              />
              <label
                for="default-checkbox-3"
                class="md:text-[14px] text-[13px] font-semibold text-[#000000]"
              >
                Make this Billing address
              </label>
            </div>
          }
        </div>
      }

      @if (data?.showAddressType) {
        <div class="mt-3">
          <div class="flex items-baseline">
            <div class="space-x-2 flex md:text-[14px] text-[13px]">
              <label>
                <input
                  formControlName="locationTypeTag"
                  class="sr-only peer"
                  type="radio"
                  value="home"
                />
                <div
                  class="cursor-pointer w-[80px] h-[40px] flex items-center justify-center text-[#000000] peer-checked:font-semibold peer-checked:text-[#F94D00] peer-checked:border-[#F94D00] border border-solid"
                  style="border-color: #dfdfdf !important"
                >
                  Home
                </div>
              </label>
              <label>
                <input
                  formControlName="locationTypeTag"
                  class="sr-only peer"
                  type="radio"
                  value="office"
                />
                <div
                  class="cursor-pointer w-[80px] h-[40px] flex items-center justify-center text-[#000000] peer-checked:font-semibold peer-checked:text-[#F94D00] peer-checked:border-[#F94D00] border border-solid"
                  style="border-color: #dfdfdf !important"
                >
                  Office
                </div>
              </label>
              <label>
                <input
                  formControlName="locationTypeTag"
                  class="sr-only peer"
                  type="radio"
                  value="other"
                />
                <div
                  class="cursor-pointer w-[80px] h-[40px] flex items-center justify-center text-[#000000] peer-checked:font-semibold peer-checked:text-[#F94D00] peer-checked:border-[#F94D00] border border-solid"
                  style="border-color: #dfdfdf !important"
                >
                  Other
                </div>
              </label>
            </div>
          </div>
        </div>
      }
    </div>

    <div
      class="flex justify-end md:mx-[0px]"
      [ngClass]="{ 'md:mt-12': !isSignUp() }"
    >
      <button
        type="submit"
        [disabled]="isButtonDisabled()"
        style="border-color: #162f4d !important; padding: 8px 35px"
        class="p-[10px] cursor-pointer rounded-[5px] text-[13px] font-bold border bg-[#162F4D] disabled:bg-[#DFDFDF] text-[#FFFFFF] disabled:text-[#5B5B5B] disabled:cursor-auto md:w-auto w-full mb-[10px] h-[40px]"
      >
        Save and Continue
      </button>
    </div>
  </div>
</form>
